import { Injectable } from '@angular/core';
import {Headers,Http} from "@angular/http";
import {environment} from "../../../environments/environment";
import { NgModel } from '@angular/forms';

@Injectable()
export class CardImagesService {
      private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
      constructor(
        private http: Http
      ) { }

      //Fetch All Cardlist registered
      getCardImagesList(offset,searchText,card_id) {
        let body = "offset="+offset+"&searchText="+searchText+"&card_id="+card_id+""
        const promise = new Promise((resolve, reject) => {
        const apiURL = environment.BASE_URL+'/cardimageslist';
            this.http.post(apiURL,body,{headers: this.headers})
            .toPromise()
            .then(
              res => { // Success
                resolve(res.json());
              }
            ).catch(
            err => {
              console.log(err.json());
              reject(err.json());
            }
          );
        });
        return promise;
      }

    //Fetch single card_image information
    getCardImageInfo(iCardImageId){
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL+'/cardimageinfo/'+iCardImageId;
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    //Fetch single card_image information
    getCategories(){
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL+'/categories';
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    //Delete Card
    deleteCardImageCall(iCardImageId){
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL+'/deletecardimage/'+iCardImageId;
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
        });
        return promise;
    }

    createCardImage(cardValue){
        const promise = new Promise((resolve, reject) => {
            let body = "card_id="+cardValue.card_id+"&x="+cardValue.x+"&height="+cardValue.height+"&y="+cardValue.y+"&width="+cardValue.width;
            const apiURL = environment.BASE_URL+'/cardimages/create';
            this.http.post(apiURL,body,{headers: this.headers})
                .toPromise()
                .then(
                    res => { // Success
                        //console.log(res.json());
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    updateCardImage(cardValue){
        const promise = new Promise((resolve, reject) => {
            let body = "card_images_id="+cardValue.card_images_id+"&x="+cardValue.x+"&height="+cardValue.height+"&y="+cardValue.y+"&width="+cardValue.width;
            const apiURL = environment.BASE_URL+'/cardimages/update';
            this.http.post(apiURL,body,{headers: this.headers})
                .toPromise()
                .then(
                    res => { // Success
                        //console.log(res.json());
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/card_imagesmaster/services/card_images.service.ts